import ExcelJS from "exceljs";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const getStatusLabel = (item) => {
  if (item?.status) return item.status;
  return item?.isActive ? "Active" : "Inactive";
};

export const ExportIeIssue = ({ ieIssueData = [], loadExportData }) => {
  const resolveExportData = async () => {
    if (typeof loadExportData === "function") {
      const data = await loadExportData();
      return Array.isArray(data) ? data : ieIssueData;
    }

    return ieIssueData;
  };

  const exportToExcel = async () => {
    const rows = await resolveExportData();
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("IE Issue Types");
    const boldFont = { bold: true };

    const currentDate = new Date();
    const formattedDate = `${currentDate.getDate()}-${currentDate.getMonth() + 1}-${currentDate.getFullYear()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `IE Issue Type Details Generated on: ${formattedDate}, ${formattedTime}`;

    worksheet.addRow(["", "", downloadDateTime, ""]);
    worksheet.mergeCells(1, 2, 1, 4);
    worksheet.getCell(1, 2).value = downloadDateTime;
    worksheet.getCell(1, 2).font = boldFont;
    worksheet.getCell(1, 2).alignment = { horizontal: "center" };

    worksheet.addRow(["", "", "IE Issue Type List", ""]);
    worksheet.mergeCells(2, 2, 2, 4);
    worksheet.getCell(2, 2).value = "IE Issue Type List";
    worksheet.getCell(2, 2).font = boldFont;
    worksheet.getCell(2, 2).alignment = { horizontal: "center" };

    const tableHeaderRow = worksheet.addRow([
      "S.No",
      "KPI Type",
      "Issue Type",
      "Status",
    ]);
    tableHeaderRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
      cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
      cell.alignment = { horizontal: "left" };
      if (colNumber >= 1 && colNumber <= 4) {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "003366" },
          bgColor: { argb: "FFFFFFFF" },
        };
      }
    });

    rows.forEach((item, index) => {
      worksheet
        .addRow([
          index + 1,
          item.kpiTypeName || item.kpiType || "N/A",
          item.issueType || "N/A",
          getStatusLabel(item),
        ])
        .eachCell({ includeEmpty: true }, (cell) => {
          cell.alignment = { horizontal: "center" };
        });
    });

    worksheet.columns = [
      { width: 5 },
      { width: 20 },
      { width: 20 },
      { width: 20 },
    ];

    try {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const url = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = url;
      anchor.download = "IEIssueTypeDetails.xlsx";
      anchor.click();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating Excel file:", error);
    }
  };

  const exportToPDF = async () => {
    const rows = await resolveExportData();
    const doc = new jsPDF({ orientation: "landscape" });
    const currentDate = new Date();
    const formattedDate = `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()}`;
    const formattedTime = `${currentDate.getHours()}:${currentDate.getMinutes()}:${currentDate.getSeconds()}`;
    const downloadDateTime = `IE Issue Type Report Generated on: ${formattedDate} ${formattedTime}`;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(16);
    doc.text("IE Issue Type List", 14, 20);
    doc.setFontSize(12);
    doc.text(downloadDateTime, 14, 30);

    const tableColumn = ["S.No", "KPI Type", "Issue Type", "Status"];
    const tableRows = rows.map((row, index) => [
      index + 1,
      row.kpiTypeName || row.kpiType || "N/A",
      row.issueType || "N/A",
      getStatusLabel(row),
    ]);

    autoTable(doc, {
      startY: 40,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",
      styles: {
        fontSize: 8,
        cellPadding: 2,
        overflow: "linebreak",
        valign: "middle",
      },
      headStyles: {
        fillColor: [0, 51, 102],
        textColor: [255, 255, 255],
        fontStyle: "bold",
      },
      bodyStyles: {
        fontSize: 8,
        halign: "left",
      },
    });
    doc.save("IEIssueTypeDetails.pdf");
  };

  return (
    <>
      <button type="button" onClick={exportToExcel} className="button-container ms-3">
        <i className="fa-solid fa-file-excel me-1 icon-container"></i> Excel
      </button>
      <button type="button" onClick={exportToPDF} className="button-container ms-3">
        <i className="fa-solid fa-file-pdf me-1 icon-container"></i> PDF
      </button>
    </>
  );
};

export default ExportIeIssue;
